import React, { useState, useEffect } from 'react'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import './styles.less'
import ProjectNameWidget from '../../../widgets/projectProposal/project/ProjectNameWidget'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import BtnEditAll from '../../../components/buttons/btnEditAll/BtnEditAll'
import { startLoading, doneLoading } from '../../../utils/loading'
import { getProjectName, getSubProjectName } from '../../../redux/actions/projectName'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import { getIsEditAll, setIsEditAll, handleOnChangeIsEdit } from '../../../utils/widget'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import ProjectBasicInfo from '../../../widgets/projectBasicInfo/ProjectBasicInfo'

export default function ProjectName(props) {
  const [isEditWidget, setIsEditWidget] = useState({})
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [showEditAll, setShowEditAll] = useState()
  const [error, setError] = useState()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  useEffect(() => {
    console.log('load ProjectName projectId', projectId)

    handleGetSchema(projectId)
  }, [])

  const handleGetSchema = async (proposalId) => {
    setIsLoading(true)
    startLoading()
    try {
      const _schema = await getSubProjectName(proposalId)

      setSchema(_schema)
      setIsEditWidget({
        projectName: _schema.forms?.projectName?.id ? false : true,
      })

      setShowEditAll(!_schema.forms?.projectName?.disabled)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal isSubProject>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isSubProject>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <>
      {schema && (
        <SidebarProposal isSubProject>
          <ContentHeader header={schema.header} subHeader={schema.subHeader} />

          {showEditAll && (
            <BtnEditAll
              onClickEditAll={getIsEditAll(isEditWidget)}
              setOnClickEditAll={(_isEdit) => setIsEditAll(_isEdit, isEditWidget, setIsEditWidget)}
            />
          )}

          {schema?.forms?.projectInfo && (
            <>
              <ProjectBasicInfo schema={schema.forms.projectInfo} />
              <br />
            </>
          )}

          {schema?.forms?.projectName && (
            <ProjectNameWidget
              showCommandButton={!schema.forms.projectName.disabled}
              schema={schema.forms.projectName}
              isEdit={isEditWidget.projectName}
              isSubProject={true}
              onChangeIsEdit={(_isEdit) =>
                handleOnChangeIsEdit('projectName', _isEdit, setIsEditWidget)
              }
            />
          )}

          <br />
        </SidebarProposal>
      )}
    </>
  )
}
